var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5018 11.5018L15.5018 9.50175M10.5018 8.50176L12.5018 6.50176M7.50176 5.50176L9.50175 3.50176M16.5018 14.5018L18.5018 12.5018M20.3018 14.3018C20.5255 14.5247 20.703 14.7897 20.8242 15.0814C20.9453 15.3731 21.0076 15.6859 21.0076 16.0018C21.0076 16.3176 20.9453 16.6304 20.8242 16.9221C20.703 17.2138 20.5255 17.4788 20.3018 17.7018L17.7018 20.3018C17.4788 20.5255 17.2138 20.703 16.9221 20.8242C16.6304 20.9453 16.3176 21.0076 16.0018 21.0076C15.6859 21.0076 15.3731 20.9453 15.0814 20.8242C14.7897 20.703 14.5247 20.5255 14.3018 20.3018L1.70176 7.70176C1.25231 7.25013 1 6.63891 1 6.00176C1 5.3646 1.25231 4.75338 1.70176 4.30176L4.30176 1.70176C4.75338 1.25231 5.3646 1 6.00176 1C6.63891 1 7.25013 1.25231 7.70176 1.70176L20.3018 14.3018Z",
    stroke: "#FF5722",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon4.59ac57264854a9de657ad3ff4ff94a05.svg";
export { ForwardRef as ReactComponent };